import React, { useState, useEffect } from "react";
import { getAllData as getClassData } from "../../lib/class";
import { getAllData as getInstructorData } from "../../lib/instructorinfo";
import { getDataWithTypeForSelect, getAllType } from "../../lib/parameters";
import params from "../../data/params.json";
import courselevel from "../../data/courselevel.json";
import { use } from "react";

// eslint-disable-next-line react/prop-types
export function SchoolSelect({ value, setValue }) {
  const [school, setSchool] = useState(null);




  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("SCHOOL");
    setSchool(slct);

    if (!value) setValue(slct[0].value);
    //console.log("option",slct);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {school?.map(function (data, ix) {
          return (
            <option key={ix} value={data.value}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function ActivitySelect({ value, setValue }) {
  const [lessonType, setLessonType] = useState(null);

  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("ACTIVITY");
    setLessonType(slct);
    if (!value) setValue(slct[0].value);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {lessonType?.map(function (data, ix) {
          return (
            <option key={ix} value={data.value}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}
// eslint-disable-next-line react/prop-types
export function ChekListTypeSelect({ value, setValue }) {
  const [checkListType, setCheckListType] = useState(null);

  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("CHECKLIST");
    setCheckListType(slct);
    if (!value) setValue(slct[0].value);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {checkListType?.map(function (data, ix) {
          return (
            <option key={ix} value={data.value}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function ParameterTypeSelect({ value, setValue ,page="Edit"}) {
  const [pType, setPType] = useState(params);

  async function getParamterType() {
    const slct = await getAllType();
    setPType(slct);
    if (!value) setValue(slct[0].value);
  }

  useEffect(() => {
    //getParamterType();
    if(page === "Edit"){
      setValue(pType[0].type)
    }
    //setValue(pType[0].type)
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        <option key={0} value="All">
          All
        </option>
        {pType?.map(function (data, ix) {
          return (
            <option key={ix} value={data.type}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function LessonTypeSelect({ value, setValue }) {
  const [lessonType, setLessonType] = useState(null);

  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("LESSONTYPE");
    setLessonType(slct);
    if (!value) setValue(slct[0].value);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {lessonType?.map(function (data, ix) {
          return (
            <option key={ix} value={data.value}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function TaskTopic911Select({ value, setValue }) {
  const [taskTopic, setTaskTopic] = useState(null);

  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("TASKTOPIC911");
    setTaskTopic(slct);
    if (!value) setValue(slct[0].label);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {taskTopic?.map(function (data, ix) {
          return (
            <option key={ix} value={data.label}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function TaskTopic12Select({ value, setValue }) {
  const [taskTopic, setTaskTopic] = useState(null);

  async function getDataWithTypeFromParamter() {
    const slct = await getDataWithTypeForSelect("TASKTOPIC12");
    setTaskTopic(slct);
    if (!value) setValue(slct[0].label);
  }

  useEffect(() => {
    getDataWithTypeFromParamter();
  }, []);

  return (
    <div className="select-container">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="select-box"
      >
        {taskTopic?.map(function (data, ix) {
          return (
            <option key={ix} value={data.label}>
              {data.label}
            </option>
          );
        })}
      </select>
      <div className="icon-container">
        <i className="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  );
}

export function ClassSelect({ value, setValue }) {
  const [classlist, setClassList] = useState([]);

  async function GetData() {
    const clas = await getClassData();
    setClassList(clas);
    setValue(clas[0].id);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div>
      <label>Class</label>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {classlist.map(function (data, ix) {
            return (
              <option key={ix} value={data.id}>
                {data.class_name}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function InstructorSelect({ value, setValue }) {
  const [instructorList, setInstructorList] = useState([]);

  async function GetData() {
    const instructors = await getInstructorData();
    setInstructorList(instructors);
    //console.log("instructors", instructors);
    
    setValue(instructors[0].id);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div>
      <label>Instructor</label>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {instructorList.map(function (data, ix) {
            return (
              <option key={ix} value={data.id}>
                {data.name + " " + data.surname}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function SubInstructorSelect({ value, setValue, excludeInstructor }) {
  const [subInstructorList, setSubInstructorList] = useState([]);

  async function GetData() {
    const subInstructors = await getInstructorData();
    setSubInstructorList(subInstructors);
    //setValue(subInstructors[0].id);
  }

  useEffect(() => {
    GetData();
  }, []);

  // Filter out the selected instructor from the sub-instructor list
  const filteredSubInstructorList = subInstructorList.filter(
    (subInstructor) => subInstructor.id !== excludeInstructor
  );


  //console.log("filteredSubInstructorList",value,excludeInstructor);
  
  return (
    <div>
      <label>Sub-Instructor</label>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
           <option key={0} value={'aaa'}>Select</option>
          {filteredSubInstructorList.map(function (data, ix) {
            return (
              <option key={ix} value={data.id}>
                {data.name + " " + data.surname}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function ClassForTranskriptSelect({ value, setValue }) {
  const [classList, setClassList] = useState([6, 7, 8, 9, 10, 11, 12]);

  if (!value) setValue(6);

  return (
    <div>
      <div className="select-container">
        <select
          //name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {classList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function ClassForLessonSelect({ value, name, setValue }) {
  const [classList, setClassList] = useState([6,7,8,9,10,11,12 ]);

  if (!value) setValue(9);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {classList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}
// eslint-disable-next-line react/prop-types
export function ClassForLessonSelectForActivities({ value, name, setValue }) {
  const [classList, setClassList] = useState(["9","9-10","9-11","9-12", "10","10-11","10-12" ,"11","11-12", "12"]);

  if (!value) setValue(9);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {classList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function MonthsForGradesSelect({ value, name = "month", setValue }) {
  const [monthList, setMonthList] = useState([
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
  ]);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {monthList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function RoleSelect({ value, name = "role", setValue }) {
  const [roleList, setRoleList] = useState([
    "Student911",
    "Student12"
  ]);
{/*}
  const [roleList, setRoleList] = useState([
    "Student",
    "Student911",
    "Student12",
    "StudentSat",
  ]);
  */}

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {roleList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function RoleSelectforNewRecord({ value, name = "role", setValue }) {
  const [roleList, setRoleList] = useState([
    "Student911",
    "Student12"
  ]);

  useEffect(() => {
    setValue(roleList[0]);
  }, []);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {roleList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function RecognitionLevelSelect({ value, setValue }) {
  const [recoglevel, setRecoglevel] = useState(["State","National","International","Regional","City","School" ]);

  if (!value) setValue("Local");

  return (
    <div>
      <div className="select-container">
        <select
          //name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {recoglevel.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}


// eslint-disable-next-line react/prop-types
export function CourseDepartmentSelect({ value, name = "department", setValue }) {
  const [deptList, setDeptList] = useState([
    "English",
    "Math",
    "Science",
    "Social Studies",
    "F. Language",
    "PE/Art/Music",
    "Electives",
    "Business",
    "Computer",
  ]);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {deptList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function CourseLevelSelect({ value, name = "level", setValue }) {
  const [levelList, setLevelList] = useState(courselevel);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {levelList.map(function (data, ix) {
            return (
              <option key={ix} value={data.value}>
                {data.label}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line react/prop-types
export function CourseApScoreSelect({ value, name="apscore", setValue }) {
  const [apScoreList, setApScoreList] = useState([0,1,2,3,4,5]);

  if (!value) setValue(9);

  return (
    <div>
      <div className="select-container">
        <select
          name={name}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {apScoreList.map(function (data, ix) {
            return (
              <option key={ix} value={data}>
                {data}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// category select
export function CategorySelectForActivity({ value, setValue }) {
  const [categoryList] = useState([
    { label: "Academic/Research/Publication", value: "A/R/P" },
    { label: "Career-Oriented", value: "Career" },
    { label: "Internship", value: "Intern" },
    { label: "Community Service", value: "Service" },
    { label: "Debate/Speech/Student Govt", value: "Db/Gov" },
    { label: "Athletics Team", value: "Sports" },
    { label: "Art/Music/Theater/Dance", value: "Arts" },
    { label: "Family Responsibility", value: "Family" },
    { label: "Work", value: "Work" },
    { label: "Others/Clubs", value: "Clubs" }
  ]);

  if (!value) {
    setValue(categoryList[0].value)
  }

  return (
    <div>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => {
            console.log('Category selected:', e.target.value)
            setValue(e.target.value)
          }}
          className="select-box"
        >
          {categoryList.map(function (data, ix) {
            return (
              <option key={ix} value={data.value}>
                {data.label}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// position select
export function PositionSelectForActivity({ value, setValue }) {
  const [positionList] = useState([
    { label: "Founder", value: "1.FDR" },
    { label: "President", value: "2.PRS" },
    { label: "Officer", value: "3.OFC" },
    { label: "Organizer", value: "4.ORG" },
    { label: "Helper", value: "5.HLP" },
    { label: "Member", value: "6.MBR" }
  ]);

  if (!value) {
    setValue(positionList[0].value)
  }

  return (
    <div>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => {
            console.log('Position selected:', e.target.value)
            setValue(e.target.value)
          }}
          className="select-box"
        >
          {positionList.map(function (data, ix) {
            return (
              <option key={ix} value={data.value}>
                {data.label}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}

// ranking select
export function RankingSelect({ value, setValue }) {
  const [rankingList] = useState([
    { label: "1 or 2", value: "1 or 2" },
    { label: "3 or 4", value: "3 or 4" },
    { label: "5 or 6", value: "5 or 6" },
    { label: "7 or More", value: "7 or More" },
    { label: "Certificate", value: "Certificate" },
    { label: "Participation", value: "Participation" },
  ]);

  if (!value) {
    setValue(rankingList[0].value)
  }

  return (
    <div>
      <div className="select-container">
        <select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="select-box"
        >
          {rankingList.map(function (data, ix) {
            return (
              <option key={ix} value={data.value}>
                {data.label}
              </option>
            );
          })}
        </select>
        <div className="icon-container">
          <i className="fa-solid fa-chevron-down"></i>
        </div>
      </div>
    </div>
  );
}
